import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const PhoneSmsAvatarIcon = (props: IconProps) => (
  <Icon w="16px" h="20px" viewBox="0 0 16 20" {...props}>
    <path
      fill="#fff"
      d="M0 2.10526C0 .942559.955126 0 2.13333 0H16v20H2.13333C.955126 20 0 19.0574 0 17.8947V2.10526Z"
    />
    <path
      fillRule="evenodd"
      d="M3.5 14.5H11v-.75h1.5v3c0 .825-.675 1.5-1.5 1.5H3.5c-.825 0-1.5-.675-1.5-1.5V3.25c0-.825.675-1.5 1.5-1.5H11c.825 0 1.5.675 1.5 1.5v3H11V5.5H3.5v9ZM11 3.25H3.5V4H11v-.75Zm-7.5 13.5H11V16H3.5v.75Zm3.375-6C7.49632 10.75 8 10.2463 8 9.625 8 9.00368 7.49632 8.5 6.875 8.5S5.75 9.00368 5.75 9.625c0 .6213.50368 1.125 1.125 1.125Zm4.875-1.125c0 .6213-.5037 1.125-1.125 1.125S9.5 10.2463 9.5 9.625c0-.62132.5037-1.125 1.125-1.125s1.125.50368 1.125 1.125Zm2.625 1.125c.6213 0 1.125-.5037 1.125-1.125 0-.62132-.5037-1.125-1.125-1.125s-1.125.50368-1.125 1.125c0 .6213.5037 1.125 1.125 1.125Z"
      clipRule="evenodd"
    />
  </Icon>
);

export default memo(PhoneSmsAvatarIcon);
